import { FC } from 'react';
import { FormikProps, FormikProvider } from 'formik';
import { Form } from 'formik-antd';
import { Radio } from 'antd';
import { truncate } from 'lodash';
import { Button, Modal } from 'components';
import * as Styles from './styles';

export type ModalSelectProps = {
  textButton?: string;
  visibleModal?: boolean;
  maskClosable?: boolean;
  data: SelectItemProps[];
  name: string;
  fetchBranchs?: () => void;
  formik: FormikProps<{ branch: string | null }>;
  setVisible?: (visible: boolean) => void;
};
export type SelectItemProps = { key: string | number; label: string };
const ModalSelect: FC<ModalSelectProps> = ({
  textButton,
  visibleModal,
  name,
  fetchBranchs,
  data = [],
  formik,
  setVisible,
  maskClosable,
}) => {
  return (
    <>
      {textButton && (
        <Styles.ButtonSelectBranch
          onClick={() => {
            fetchBranchs && fetchBranchs();
          }}
        >
          {textButton}
        </Styles.ButtonSelectBranch>
      )}

      <Modal
        visible={!!visibleModal}
        maskClosable={!!maskClosable}
        footer={false}
        width="1056px"
        maskStyle={{ backgroundColor: '#949494' }}
        onOk={() => setVisible && setVisible(false)}
        onCancel={() => setVisible && setVisible(false)}
      >
        <Styles.Container>
          <Styles.Header>支店を選択</Styles.Header>
          <Styles.SectionStyle>
            <FormikProvider value={formik}>
              <Form>
                <Radio.Group
                  size="middle"
                  style={{ width: '1008px' }}
                  onChange={formik.handleChange}
                  name={name}
                  value={formik.values.branch}
                  defaultValue={formik.initialValues.branch}
                >
                  {data &&
                    data.map((i) => (
                      <Styles.RadioButonStyle value={i.key} key={i.key}>
                        {truncate(i.label, {
                          length: 14,
                        })}
                      </Styles.RadioButonStyle>
                    ))}
                </Radio.Group>
              </Form>
            </FormikProvider>
          </Styles.SectionStyle>
          <div className="footer">
            <Button disabled={!formik.values.branch} onClick={() => formik.handleSubmit()}>
              確定
            </Button>
          </div>
        </Styles.Container>
      </Modal>
    </>
  );
};

export default ModalSelect;
